import { memo } from 'react';

import {
  RarityCard,
  type RarityCardOuterProps,
} from '@/shared/components/ui/rarityCard';
import { cn } from '@/shared/utils/cn';

export interface ProfileOverviewCardRootProps extends RarityCardOuterProps {}

export const ProfileOverviewCardRoot = memo(
  (props: ProfileOverviewCardRootProps) => {
    const { rarity, children, className, isPremium, corners, ...rest } = props;

    return (
      <RarityCard.Outer
        rarity={rarity}
        isPremium={isPremium}
        corners={corners}
        className={cn('flex h-full w-full flex-col p-3', className)}
        {...rest}
      >
        {children}
      </RarityCard.Outer>
    );
  },
);
